var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ui-icon d-flex flex-row",class:{'dashboard-tag': _vm.dashboardTag}},[_c('span',{staticClass:"icon",class:_vm.icon}),(_vm.hasText())?_c('span',{staticClass:"text"},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }